export const fullInstitutionSubscriptionDTOFields = {
    subscriptionBasicData: 'subscriptionBasicData',
    institution: 'institution',
    institutionOwner: 'institutionOwner',
    balance: 'balance',
} as const;
